import { TaskType } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import {
  WritebackSettingMode,
  WritebackSettingName,
} from '@weave/schema-gen-ts/dist/shared/call-intelligence/enums.pb';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { i18next } from '@frontend/i18n';
import { CallIntelSettingsTrackingIds } from './tracking-ids';

export const SyncOptionsList: {
  label: string;
  description: string;
  value: WritebackSettingMode;
  trackingId: string;
}[] = [
  {
    label: i18next.t('Off', { ns: 'settings>>call-intel-settings' }),
    description: i18next.t('Prevents call summaries from being uploaded to your PMS or EHR.', {
      ns: 'settings>>call-intel-settings',
    }),
    value: WritebackSettingMode.WRITEBACK_SETTING_MODE_OFF,
    trackingId: CallIntelSettingsTrackingIds.pmsSync.syncOptionOff,
  },
  {
    label: i18next.t('Manual', { ns: 'settings>>call-intel-settings' }),
    description: i18next.t('Use the Sync button to manually upload the call summary to your PMS or EHR.', {
      ns: 'settings>>call-intel-settings',
    }),
    value: WritebackSettingMode.WRITEBACK_SETTING_MODE_MANUAL,
    trackingId: CallIntelSettingsTrackingIds.pmsSync.syncOptionManual,
  },
  {
    label: i18next.t('Automatic', { ns: 'settings>>call-intel-settings' }),
    description: i18next.t('Every call summary is  automatically uploaded to your PMS or EHR after each call.', {
      ns: 'settings>>call-intel-settings',
    }),
    value: WritebackSettingMode.WRITEBACK_SETTING_MODE_AUTOMATIC,
    trackingId: CallIntelSettingsTrackingIds.pmsSync.syncOptionAutomatic,
  },
];

export const CALL_INTEL_SYNC_HELP_LINK =
  'https://www.weavehelp.com/weavehelp/article/pms-writebacks-call-intelligence?queryID=fd03622515765d8f2a9b4df1c335a091&objectID=pms-writebacks-call-intelligence';
export const CALL_SUMMARY_SYNC_SETTING_NAME = WritebackSettingName.WRITEBACK_SETTING_CALL_SUMMARY;
export const TASK_SETTINGS_PERMISSION = Permission.CALL_INTELLIGENCE_MANAGE_AI_TASK_SETTINGS;

export const TASK_TYPE_LIST = [
  TaskType.TYPE_SCHEDULING,
  TaskType.TYPE_WAITLIST,
  TaskType.TYPE_PATIENT_CARE,
  TaskType.TYPE_BILLING,
  TaskType.TYPE_INSURANCE,
  TaskType.TYPE_OTHER,
] as const;
